/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable camelcase */
/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  filter,
  first, forEach, get, includes, isEmpty,
  map,
} from 'lodash';
import { withLocalize } from 'react-localize-redux';
import { setCart } from '../../../Actions';
import ColumnsList from '../../Shared/ColumnsList';
import { InfoOutlined } from '@material-ui/icons';
import LatestModalDesign from '../../Shared/LatestModalDesign';
import { isEventBooking } from '../../../constants';
import TriggersTooltips from '../../Shared/ClickableTooltip';

class OrderSummary extends React.Component {
  constructor(props) {
    super(props);

    this.renderBillingLineItems = this.renderBillingLineItems.bind(this);
    this.renderSecondBollingLineItems = this.renderSecondBollingLineItems.bind(this);
    this.tippingMessage = this.tippingMessage.bind(this);
    this.bookingFeeModal = this.bookingFeeModal.bind(this);
    this.genericTooltipModal = this.genericTooltipModal.bind(this);

    this.state = {
      showBookingFeeModal: false,
      tooltip: null,
    };
  }

  renderBillingLineItems() {
    const arr = [];
    const billing = get(this.props, 'booking.cart.billing', null);
    if (!isEmpty(billing)) {
      let { top_billing_line_items } = billing;

      if (isEventBooking() && this.props.isReviewStep) {
        top_billing_line_items = filter(top_billing_line_items, (el) => (el.title !== "Tip"));
      }

      if (!isEmpty(top_billing_line_items)) {
        forEach(top_billing_line_items, (item) => {
          let price; const
            strikedThroughText = item.strike_through_text ? <span className="gray-strike-through">{item.strike_through_text}</span> : null;
          if (`${item.amount}`.startsWith('-')) {
            price = <span className="color-green">{item.amount}</span>;
          } else {
            price = (
              <span>
                {strikedThroughText}
                {' '}
                {item.amount}
              </span>
            );
          }
          let additionalTag = null;
          if (item.tooltip_title) {
            let { tooltip_title, tooltip_text, tooltip_text_links } = item;

            let temp = null;
            if (isEmpty(tooltip_text_links)) {
              temp = tooltip_text;
            } else {
              map(tooltip_text_links, (item2) => {
                // note: order of links matter
                const { text, link } = item2;
                let splittedArr = tooltip_text.split(text);
                if (!temp) {
                  temp = splittedArr[0]
                }
                let part2 = splittedArr[1];
                temp = (<>{temp}{' '}{<a className='underline BluePrimary' href={link} target="_blank" rel="noopener noreferrer">{text}</a>}{part2}</>)
              })
            }
            additionalTag = <InfoOutlined className="contentSecondary cursor-pointer w-h-20 ml-6" onClick={() => {
              this.setState({
                tooltip: {
                  title: tooltip_title,
                  subtitle: temp
                }
              })
            }} />;
          }

          if (!isEmpty(item.subtitles)) {
            forEach(item.subtitles, (subtitle, ind) => {
              if (ind === 0) {
                arr.push({ text: <div className='d-flex-only align-items-center'><span className='contentPrimary medium-font'>{item.title}</span>{" "}{additionalTag}</div> });
                arr.push({ text: subtitle, price });
              } else {
                arr.push({ text: '- ' + subtitle });
              }
            });
          } else if (item.subtitle) {
            // Check if this is a SoothePass related subtitle
            const isSoothePassSubtitle = item.title && item.title.toLowerCase().includes('soothepass');
            const marginLeft = isSoothePassSubtitle ? '32px' : '16px';
            
            arr.push({ text: <>{item.title} {additionalTag}</>, price });
            arr.push({ 
              text: <div className="size-12-20 clr-light-gray" style={{ marginLeft }}>{item.subtitle}</div>
            });
          } else {
            arr.push({ text: <>{item.title} {additionalTag}</>, price });
          }
        });
      }
    }
    return arr;
  }

  renderSecondBollingLineItems() {
    const arr = [];
    const billing = get(this.props, 'booking.cart.billing', null);
    if (!isEmpty(billing)) {
      let { bottom_billing_line_items } = billing;

      if (isEventBooking() && this.props.isReviewStep) {
        bottom_billing_line_items = filter(bottom_billing_line_items, (el) => (el.title !== "Tip"));
      }

      if (!isEmpty(bottom_billing_line_items)) {
        forEach(bottom_billing_line_items, (itm) => {
          // if (includes(itm.title, 'Booking Fee')) {
          //   arr.push({
          //     text: <div className='d-flex-only align-items-center'>{itm.title}{" "}<InfoOutlined className="contentSecondary cursor-pointer w-h-20 ml-6" onClick={() => {
          //       this.setState({
          //         tooltip: {
          //           title: "Appointment Booking Fee",
          //           subtitle: "This fee helps cover essential technology and regulatory costs, ensuring a seamless booking experience while allowing independent providers to focus on delivering exceptional wellness services."
          //         }
          //       })
          //     }} /></div>, price: itm.amount
          //   });
          // } else {
          if (itm.tooltip_title) {
            let { tooltip_title, tooltip_text, tooltip_text_links } = itm;

            let temp = null;
            if (isEmpty(tooltip_text_links)) {
              temp = tooltip_text;
            } else {
              map(tooltip_text_links, (item2) => {
                // note: order of links matter
                const { text, link } = item2;
                let splittedArr = tooltip_text.split(text);
                if (!temp) {
                  temp = splittedArr[0]
                }
                let part2 = splittedArr[1];
                temp = (<>{temp}{' '}{<a className='underline BluePrimary' href={link} target="_blank" rel="noopener noreferrer">{text}</a>}{part2}</>)
              })
            }

            arr.push({
              text: <div className='d-flex-only align-items-center'>{itm.title}{" "}<InfoOutlined className="contentSecondary cursor-pointer w-h-20 ml-6" onClick={() => {
                this.setState({
                  tooltip: {
                    title: tooltip_title,
                    subtitle: temp
                  }
                })
              }} />
              </div>, price: itm.amount
            });
          } else {
            arr.push({ text: itm.title, price: itm.amount });
          }
          // }
        });
      }
    }
    return arr;
  }
  bookingFeeModal() {
    return <LatestModalDesign
      contentExtraClass="modal-content-exception"
      footerExtraClass="sm-fix-exception"
      title="Appointment Booking Fee"
      subtitle="This fee helps cover essential technology and regulatory costs, ensuring a seamless booking experience while allowing independent providers to focus on delivering exceptional wellness services."
      isOpen={this.state.showBookingFeeModal}
      hideBackArrow
      hideCancel
      applyBtnCopy="Close"
      apply={() => this.setState({ showBookingFeeModal: false })}
    />;
  }

  genericTooltipModal() {
    let { tooltip } = this.state;
    return <LatestModalDesign
      contentExtraClass="modal-content-exception"
      footerExtraClass="sm-fix-exception"
      title={tooltip?.title}
      subtitle={tooltip?.subtitle}
      isOpen={isEmpty(tooltip) ? false : true}
      hideBackArrow
      hideCancel
      applyBtnCopy="Close"
      apply={() => this.setState({ tooltip: null })}
    />;
  }

  tippingMessage() {
    const { cart } = this.props.booking;
    return cart && cart.cart_messages ? first(cart.cart_messages) : '';
  }

  render() {
    const price_with_tip = isEventBooking() && this.props.isReviewStep ? get(this.props, 'booking.cart.billing.price', '') : get(this.props, 'booking.cart.billing.price_with_tip', '');
    const isReviewStep = get(this.props, 'bookingFlow.step.id', '') === "REVIEW";

    return (
      <div>
        {isReviewStep ? null : <div className="second-title-style">Order Summary</div>}
        <div className="br-btm-gray-thin">
          <ColumnsList
            itemsList={this.renderBillingLineItems()}
          />
        </div>
        <div className="br-btm-gray-thin">
          <ColumnsList
            itemsList={this.renderSecondBollingLineItems()}
          />
        </div>
        <ColumnsList
          headerText="Due today"
          headerPrice={price_with_tip}
        />
        {this.bookingFeeModal()}
        {this.genericTooltipModal()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.client,
  booking: state.booking,
  bookingFlow: state.bookingFlow,
});

OrderSummary.propTypes = {
  booking: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  setCart: PropTypes.func.isRequired,
};

export default withLocalize(connect(mapStateToProps, { setCart })(OrderSummary));
